import { render } from "./AddTrainer.vue?vue&type=template&id=9978b73a&ts=true"
import script from "./AddTrainer.vue?vue&type=script&lang=ts"
export * from "./AddTrainer.vue?vue&type=script&lang=ts"

import "./AddTrainer.vue?vue&type=style&index=0&id=9978b73a&lang=css"
import "./AddTrainer.vue?vue&type=style&index=1&id=9978b73a&lang=css"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__